import { render, staticRenderFns } from "./left-tree.vue?vue&type=template&id=c5040fa4&"
import script from "./left-tree.vue?vue&type=script&lang=js&"
export * from "./left-tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5040fa4')) {
      api.createRecord('c5040fa4', component.options)
    } else {
      api.reload('c5040fa4', component.options)
    }
    module.hot.accept("./left-tree.vue?vue&type=template&id=c5040fa4&", function () {
      api.rerender('c5040fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AreaSelect/left-tree.vue"
export default component.exports